"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.loadingErrorImage = void 0;
var loadingErrorImage = '/images/loadingError.svg';
/**
 * The props for the ErrorBanner control.
 */

exports.loadingErrorImage = loadingErrorImage;